import { render, staticRenderFns } from "./ActivationEmailDetail.vue?vue&type=template&id=64342c93&scoped=true&"
import script from "./ActivationEmailDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmailDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmailDetail.vue?vue&type=style&index=0&id=64342c93&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64342c93",
  null
  
)

export default component.exports